// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__2St7Y","btnRed":"styles_btnRed__rlfpF","container":"styles_container__1a-4g","group":"styles_group__2gv7H","text":"styles_text__3Z2dE"};